<template>
    <div id="dashboard-menu" class="f fc">
        
        <div class="f fw  home-link">
            <img src="../assets/images/logo.png"  style="width:45%"/>
        
            <router-link class="f" to="/dashboard"  >
                <q-btn  v-ripple icon="mdi-home" style="color:#777;font-size:18px;margin:0 0 0 25px;"/>
            </router-link>
        </div>

        <div class="f fc links">

        <router-link v-for="l in links" v-ripple :to="l.url || '/'+l.name" :key="l.name" class="f fw">
            <q-icon :name="l.icon"/>
            <b>{{l.name.toUpperCase()}}</b>
            <q-icon name="mdi-chevron-right"/>
            <div class="hr" />
        </router-link>

            
        </div>
        <div class="f links" style="margin:auto 0 20px; justify-content: center">
            <img src="../assets/images/logo.png"  style="width:55%"/>
            <!-- <q-btn color="negative" @click="logout">ESCI DA {{$store.state.usr.name}}</q-btn> -->
        </div>
    </div>
</template>
<script>
import {when} from 'mobx';
export default {
    data:()=>({
        isMounted:false,
        links: []
    }),
    async mounted(){
        await when(()=>!!this.$authToken._id)
        let links =  [
          {
            name: 'soggetti',
            icon: 'mdi-account-group'
          },{
            name: 'informative',
            icon: 'mdi-file-document'
          },{
            name: 'In attesa',
            icon: 'mdi-timer-sand',
            url:'/pending'
          },
          {name: 'DATI AZIENDALI',url: '/dati-aziendali',icon: 'mdi-form-select'},
        ]
        if (this.$store.state.usr.sections ) {
            if (this.$store.state.usr.sections.includes('comunicazioni')) {
                links.push( {name: 'comunicazioni',icon: 'mdi-bullhorn'},)
            }
            if (this.$store.state.usr.sections.includes('archivio')) {
                links.push({name: 'archivio',icon: 'mdi-folder'},)
            }
            if (this.$store.state.usr.sections.includes('dispositivi')) {
                links.push({  name: 'DISPOSITIVI',  url: '/devices',  icon: 'mdi-tablet'})
            }
        }

        this.links.push(...links);

        /* if (this.$store.state.usr.role?.admin) {
            
        } */
        this.links.push({
            name: 'MODULI DATI',
            url: '/forms',
            icon: 'mdi-form-textbox'
        },);
        
        if (this.$store.getters.isAdmin)
        this.links.unshift({
                name:'utenti',
                icon: 'mdi-account',
                url:'/users'
            })
          
        this.isMounted = true;
    },
    methods:{
        logout(){
            this.$store.state.commit('logout',{});
        }
    }
}
</script>
<style lang="scss" scoped>
#dashboard-menu {
    background-color: #333;
    height: 100vh;
    width: 220px;
    position: fixed;
    left:0;
    top:0;
    box-shadow: 0 0px 10px 3px #0008;
    justify-content: flex-start;

    //transition:transform ease-in-out .7s;
    //transform: translateX(-100%);
    &.opened {
        transform: translateX(0);
    }
    h3 {
        font-size:18px;
        color: #dedede;
        line-height: 1.4rem;
    }
    
    .links {
        align-items: flex-start;
        a {
            position: relative;
            color:#eee;
            text-decoration: none;
            padding:15px 10px;
            font-size:13px;
            border-bottom:1px solid #222;
            text-transform: uppercase;
            
            i {
                margin: 0 10px 4px;
                font-size:22px;
                
            }
            i.mdi-chevron-right {
                margin:0 0 0 auto;
                transform: translateX(0);
            }
            i.mdi-chevron-right, b {
                transition: transform 0.15s ease-out;
            }
            .hr {
                transition : transform .3s ease-in-out;
                transform: scaleX(0);
                background-color:#888;
                position: absolute;
                width: 70%;
                height:1px;
                left:15%;
                bottom:20%;
            }
            &.router-link-active {
                background-color: #444;
              
            }
            &:hover {
                .hr {
                    transform: scaleX(1)
                }
                
                i.mdi-chevron-right {
                    transform: translateX(-10px);
                }
                b {
                    transform: translateX(4px);
                }
            }
        }
    }
    .home-link {
        border-bottom:1px solid #000;
        padding-bottom:20px;
        background-color:#dedede;
        box-shadow: inset 0 2px 5px #000a;
        padding-top:20px
    }
}
</style>